import { formatNumber } from 'accounting';
import { StyledLabel } from '../common';

interface NumberCellContentProps {
  data: number;
}

export const NumberCellContent = ({ data }: NumberCellContentProps) => {
  const formattedValue = formatNumber(data);

  return <StyledLabel>{formattedValue}</StyledLabel>;
};
